var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"mt-5"},[_vm._v("\n        Sorry you currently don't have access to this page, please contact your Organisation Administrator to request access.\n    ")])])
}]

export { render, staticRenderFns }